import { Grid, Text } from "@nextui-org/react"
import { useNavigate } from "react-router-dom"

import Header from "../../../ui/header"
import { Content } from "../../../ui/layout/content"
import { Box } from "../../../ui/layout/box"
import Button from "../../../ui/button"

export default ({}) => {
    const navigate = useNavigate()

    return (
        <>
            <Grid.Container>
                <Grid xs={12} sm={5} css={{flexDirection: "column", alignItems: "center"}}>
                    <Content spacerSize={2}>
                        <Box>
                            <Header h2 centered value="Thank You!"/> 
                            <Text size="$sm" css={{lineHeight: "$sm", mt: "$sm", ta: "center"}}>Your application has been submitted successfully. We'll get in touch with you soon.</Text>
                        </Box>
                    </Content>
                    <Content spacerSize={3}>
                        <Button 
                            text="Back to Opportunities"
                            onClick={() => navigate('/opportunities')}/>
                    </Content>
                </Grid>
            </Grid.Container>
        </>
    )
}